import { useState, useEffect } from "react";
import { useModal } from "../../hooks";
import LavorisService from "../../services/LavorisService";
import AddRRHHTurnsCandidate from "../others/userModule/RRHHTurnsCadidate/addRRHHTurnsCandidate";
import EditRRHHTurnsCandidate from "../others/userModule/RRHHTurnsCadidate/editRRHHTurnsCandidate";
import InfiniteTable from "../../components/others/InfiniteTableComponent/IntiniteTableComponent";
import { getUserRolesTableColumns } from "./userRolesTableColumns";

const ADD_RRHH_TURNS_CANDIDATE_MODAL = "addRRHHTurnsCandidateModal";
const EDIT_RRHH_TURNS_CANDIDATE_MODAL = "editRRHHTurnsCandidateModal";

const RRHHTurnsCandidate = () => {
  const LavorisInstance = LavorisService.getInstance();

  // useStates
  const [tableLoading, setTableLoading] = useState(true);
  const { openModal, closeModal, isActive } = useModal();
  const [RRHHTurns, setRRHHTurns] = useState<any[]>([]);
  const [RRHHTurn, setRRHHTurn] = useState<any>(null);


  const getItems = async () => {
    setTableLoading(true);
    try {
      const response = await LavorisInstance.User.findUsersByRoleAlias(
        "CANDIDATE_APPOINTMENTS",
      );
      setRRHHTurns(response);
    } catch (error) {
      console.log(error);
    } finally {
      setTableLoading(false);
    }
  };

  useEffect(() => {
    const getData = async () => {
      await getItems();
    };
    getData();
  }, []);

  // Configuración de columnas para la tabla (sin email ni emailEnabled)
  const requestedTurnsColumns = getUserRolesTableColumns(
    (rowData) => {
      openModal(EDIT_RRHH_TURNS_CANDIDATE_MODAL, rowData.id);
      setRRHHTurn(rowData);
    },
    { showEmail: false, showEmailEnabled: false }
  );

  return (
    <>
      <div className="custom-header mt-sm-4 mt-0 pt-2">
        <div className="header-controls">
          {/* Search Section */}
          <div className="search-section">
          </div>

          {/* Actions Section */}
          <div className="actions-section">
            <button
              type="button"
              className="add-btn"
              onClick={() => {
                openModal(ADD_RRHH_TURNS_CANDIDATE_MODAL);
              }}
              title="Agregar"
            >
              <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
                <path
                  d="M8 3.333v9.334M3.333 8h9.334"
                  stroke="currentColor"
                  strokeWidth="1.5"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
              <span className="btn-text">Agregar</span>
            </button>
          </div>
        </div>
      </div>

      <InfiniteTable
        data={RRHHTurns}
        columns={requestedTurnsColumns}
        loading={tableLoading}
        hasMore={false}
        onLoadMore={() => { }}
        height={300}
        emptyMessage="Momentáneamente no hay datos para mostrar"
        loadingMessage={RRHHTurns.length === 0 ? "Cargando datos..." : "Buscando más datos..."}
        striped
        hover
        bordered
      />


      {isActive(ADD_RRHH_TURNS_CANDIDATE_MODAL) && (
        <AddRRHHTurnsCandidate
          show
          urlTittle={ADD_RRHH_TURNS_CANDIDATE_MODAL}
          onClose={() => closeModal(ADD_RRHH_TURNS_CANDIDATE_MODAL)}
          modalTittle="Agregar RRHH de Turnos Postulantes"
          tableLoading={getItems}
        />
      )}

      {isActive(EDIT_RRHH_TURNS_CANDIDATE_MODAL) && (
        <EditRRHHTurnsCandidate
          show
          urlTittle={EDIT_RRHH_TURNS_CANDIDATE_MODAL}
          onClose={() => closeModal(EDIT_RRHH_TURNS_CANDIDATE_MODAL)}
          modalTittle="Editar RRHH de Turnos"
          data={RRHHTurn}
          tableLoading={getItems}
        />
      )}
    </>
  );
};

export default RRHHTurnsCandidate;
